import React from "react";
import { Dialog, Flex, Text, Button } from "@radix-ui/themes";

export function SevenRoomsPullScopeDialog({ isOpen, onOpenChange, onChoose }) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content maxWidth="500px">
        <Dialog.Title>Choose how this pull starts</Dialog.Title>
        <Dialog.Description size="2" mb="3">
          Choose whether to import guest profiles already present at the mapped
          SevenRooms venues, or skip them and process only future client-created
          and client-updated events.
        </Dialog.Description>
        <Text size="2" color="gray" mb="4" as="p">
          This choice only affects pulling from SevenRooms. Your push setting is unchanged.
        </Text>
        <Flex justify="end" gap="3" wrap="wrap">
          <Button
            variant="soft"
            color="accent"
            onClick={() => onChoose("existing")}
          >
            Import existing profiles
          </Button>
          <Button
            variant="outline"
            color="gray"
            onClick={() => onChoose("from_now")}
          >
            Start with future changes
          </Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
